import React, { useEffect, useState } from "react";
import Pagination from '@mui/material/Pagination';
import { Stack, Tooltip, Typography } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

function Content({items, limitedGraphRows, setLimitedGraphRows, maxCountPerGraph}) {
  const [page, setPage] = useState(1);
  const highestGraphCount = items ? Math.max(items.length) : 0;
  const totalGraphCount = items ? (items.length) : 0;
  const estPageGraphCount = highestGraphCount > 0 ? Math.ceil(highestGraphCount / maxCountPerGraph) : 1;
  const currentMaxFromGraph = ((page-1) * maxCountPerGraph);
  const currentMaxToGraph = ((page) * maxCountPerGraph);
  const fromCountGraph = currentMaxFromGraph;
  const toCountGraph = limitedGraphRows.length < maxCountPerGraph ? currentMaxFromGraph + limitedGraphRows.length : currentMaxToGraph;
  const rowHelpTextGraph = `The system will display up to 100 items per page. This page is displaying: \n ${maxCountPerGraph} Acre Lines`
  
  useEffect(() => {
    if(page > estPageGraphCount){
      setPage(1);
    }
  }, [estPageGraphCount, page]);

  const handleGraphPageChange = (event, value) => {
    const tempCurrentMaxFromGraph = ((value-1) * maxCountPerGraph);
    const tempCurrentMaxToGraph = ((value) * maxCountPerGraph);
    const tempFromCountGraph = tempCurrentMaxFromGraph;
    //Needs to be based on the entire array
    const tempToCountGraph = items.length < maxCountPerGraph ? tempCurrentMaxFromGraph + items.length : tempCurrentMaxToGraph;
    const remainingItems = items.slice(tempFromCountGraph, tempToCountGraph);
    if(page > estPageGraphCount){
      setPage(estPageGraphCount)
    } else {
      setPage(value)
    }
    setLimitedGraphRows(remainingItems)
  }

  return (
    <Stack direction="row" spacing={1} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'end' }}>
      <Tooltip 
        title={
          <div style={{ whiteSpace: 'pre-line' }}>{rowHelpTextGraph}</div>
        } 
        enterDelay={100}
      >
        <HelpIcon fontSize="small" color="primary" />
      </Tooltip>
      <Typography>{fromCountGraph}-{toCountGraph} of {totalGraphCount}</Typography>
      <Pagination
        page={page}
        count={estPageGraphCount}
        onChange={handleGraphPageChange}
        color="primary"
      />
    </Stack>
    
  );
}

export default function PaginationLink({items, limitedGraphRows, setLimitedGraphRows, maxCountPerGraph}) {
  return (
    <Content items={items} limitedGraphRows={limitedGraphRows} setLimitedGraphRows={setLimitedGraphRows} maxCountPerGraph={maxCountPerGraph} />
  );
}
